import React from "react"
import { DATE, SELECT, TEXT, TEXT_AREA } from "../../admin/controlPanel/intakeUtils"
import { Combobox, DatePicker, TextInput } from "@startlibs/form"
import { ComboboxContainer } from "../../request/forms/ContactDetails"
import { defaultDateFormat } from "../../utils/dateFormat"

export const CustomInput = ({input, tabId, readOnly = false, isMultiLanguage, intl}) => {

    const {description, id, name, required, type, value, options, translations} = input

    const label = isMultiLanguage
        ? (translations && translations.find(t => t.language === intl.locale)?.name) || name
        : name

    const placeholder = isMultiLanguage
        ? (() => {
            const translation = translations?.find(t => t.language === intl.locale);
            return translation?.description === "" ? "" : translation?.description || description;
            })()
        : description;

    const optionsList = isMultiLanguage
        ? (translations && translations.find(t => t.language === intl.locale)?.options?.length > 0 && translations.find(t => t.language === intl.locale)?.options) || options
        : options

    const getValue = (input, fieldValue) => {
        if (isMultiLanguage) {
            const currentTranslation = input?.translations?.find(t => t.language === intl.locale);
            const currentOptions = currentTranslation?.options || [];
            const currentIndex = currentOptions.findIndex(o => o === fieldValue);

            if (currentIndex !== -1) {
                return currentOptions[currentIndex];
            }

            // Search through all other translations
            const otherMatch = input?.translations?.find(t => {
                if (t.language === intl.locale) return false;
                return (t.options || []).includes(fieldValue);
            });
            

            if (otherMatch) {
                const indexInOther = otherMatch.options.findIndex(o => o === fieldValue);
                return currentOptions[indexInOther] || fieldValue; // Try to return corresponding option in current locale
            }
            return fieldValue;
        }

        return fieldValue;
    };

    if(type === TEXT) {
        return (
            <TextInput
                path={`${tabId}.${id}`}
                label={label}
                placeholder={placeholder}
                value={value}
                mandatory={required}
                disabled={readOnly}
            />
        )
    }

    if(type === TEXT_AREA) {
        return (
            <TextInput
                path={`${tabId}.${id}`}
                label={label}
                placeholder={placeholder}
                value={value}
                textarea
                autoResize
                mandatory={required}
                disabled={readOnly}
            />
        )
    }

    if(type === SELECT) {
        return (
            <ComboboxContainer readOnly={readOnly} style={{pointerEvents: readOnly ? "none": "all"}}>
                <Combobox
                    disabled={readOnly}
                    className="combobox"
                    placeholder={placeholder || "Please select"}
                    label={label}
                    path={`${tabId}.${id}`}
                    options={optionsList.filter(o => o !== "")}
                    getLabel={(v) => {
                        if(isMultiLanguage) {
                            return getValue(input, v)
                        }
                        return v
                    }}
                    mandatory={required}
                />
            </ComboboxContainer>
        )
    }

    if(type === DATE) {
        return (
            <DatePicker
                disabled={readOnly}
                weekStartsMonday
                label={label}
                path={`${tabId}.${id}`}
                mandatory={required}
                placeholder={placeholder || intl.formatMessage({
                    defaultMessage:`Ex: {dateFormat}`,
                    description:"Custom input date format placeholder"
                },{dateFormat:defaultDateFormat(intl).toUpperCase()})}
                format={defaultDateFormat(intl)}
            />
        )
    }

    return null

}